import { render, staticRenderFns } from "./LeavesPastData.vue?vue&type=template&id=1e0f57c1&scoped=true"
import script from "./LeavesPastData.vue?vue&type=script&lang=js"
export * from "./LeavesPastData.vue?vue&type=script&lang=js"
import style0 from "./LeavesPastData.vue?vue&type=style&index=0&id=1e0f57c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f57c1",
  null
  
)

export default component.exports